import { DefaultService } from '@/services/DefaultService';

export default class ProLpsService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    test() {
        return this._http.get(`${this._env}`, this._headers).then(res => {
            return res.body;
        });
    }

    getTheme (domain) {
        return this._http.get(`${this._env}/theme/${domain}.json`, this._headers).then(res => {
            return res.body;
        });
    }

    /* Rota sem envio de dados, ela serve apenas para conectar a ação do botão ao insert
    todos os registros salvos no banco são gerados no backend */
    sendTermo(){
        return this._http.get(`${this._env}/termoprivacidade`, this._headers).then(res => {
            return res.body;
        })
    }

}